module.exports = __webpack_public_path__ + "static/media/report.1ff31720.svg";